import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    Container as DefaultContainer,
    MultipleGroupFull,
    MultipleGroupVolunteerWithCountry
} from '../../containers/DefaultStyles/FormDetails';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';
import { validate } from './validations';
import normalizePhone from '../Widget/normalizePhone';
import { ButtonGroup } from '../../containers/DefaultStyles/Details';

import { LoadingSpinner } from '../LoadingSpinner';

import { CountryCodes } from '../../utils/enums';
import { isPortrait } from '../../utils/size';
import { getCachedFirstName, getCachedLastName } from '../../utils/formCaching/helpers';
import { copyFor, capitalization } from '../../copy/copy';

const Container = styled(DefaultContainer)`
    margin-top: 15px;
    overflow: hidden;
    height: calc(100% - 65px);
`;

const StickyButtonGroupWrapper = styled(ButtonGroup)`
    position: sticky;
    background-color: #ffffff;
    padding: 0;
    margin: 0;
    margin-top: 45px;
    width: 100%;
    bottom: 0px;
`;

const VoteRegistrationStep2Form = props => (
    <Container autocomplete="on" onSubmit={props.handleSubmit}>
        {isPortrait() ? (
            <div>
                <MultipleGroupFull>
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'firstName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'firstName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'lastName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'lastName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label={copyFor(
                            'formFields',
                            'emailAddress',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'emailAddress',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="phone"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'phone',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'phone',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                        normalize={normalizePhone}
                    />
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'postalCode',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'postalCode',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                        maxLength={5}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="countryCode"
                        countryCodeDropdown={true}
                        component={DropDownSelect}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'country',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        options={CountryCodes}
                    />
                </MultipleGroupFull>
            </div>
        ) : (
            <div>
                <MultipleGroupFull>
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'firstName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'firstName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'lastName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'lastName',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label={copyFor(
                            'formFields',
                            'emailAddress',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'emailAddress',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                    />
                </MultipleGroupFull>
                <MultipleGroupVolunteerWithCountry>
                    <Field
                        name="phone"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'phone',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'phone',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                        normalize={normalizePhone}
                    />
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'postalCode',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor(
                            'placeholders',
                            'postalCode',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        autocomplete="on"
                        maxLength={5}
                    />
                    <Field
                        name="countryCode"
                        countryCodeDropdown={true}
                        component={DropDownSelect}
                        type="text"
                        label={copyFor(
                            'formFields',
                            'country',
                            'volunteer',
                            capitalization.eachWord
                        )}
                        options={CountryCodes}
                    />
                </MultipleGroupVolunteerWithCountry>
            </div>
        )}
        <StickyButtonGroupWrapper isSubmitting={props.isSubmitting}>
            <TwoGroup>
                <Button label="Back" onClick={props.onBack} />
                <Button
                    className="submitButton"
                    primary={true}
                    type="submit"
                    label={copyFor(
                        'buttons',
                        'continue',
                        'volunteer',
                        capitalization.eachWord
                    )}
                    disabled={props.invalid}
                    onClick={props.onSubmit}
                />
                <LoadingSpinner />
            </TwoGroup>
        </StickyButtonGroupWrapper>
    </Container>
);

VoteRegistrationStep2Form.propTypes = {
    onBack: PropTypes.func,
    onSubmit: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func
};

export default compose(
    connect(state => {
        return {
            initialValues: {
                firstName: getCachedFirstName(state),
                lastName: getCachedLastName(state),
                email: state.cachedFormData.email || '',
                phone: state.cachedFormData.phone || '',
                postalCode: state.widget.endUserLocation
                    ? state.widget.endUserLocation.postalCode
                    : '',
                countryCode: state.widget.endUserLocation.countryCode
                    ? state.widget.endUserLocation.countryCode
                    : 'US',
                tos: true
            },
            isSubmitting: state.volunteer.isSubmitting
        };
    }),
    reduxForm({
        form: 'volunteer',
        validate,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep2Form);



// WEBPACK FOOTER //
// ./src/components/Volunteer/VolunteerStep2Form.jsx